import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesExplorerOrganisations: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-explorer-organisations`),
};

export default pagesExplorerOrganisations;
